import React from 'react';
import { useLang } from '../i18n/LangContext';
import { VILLAGE_SERVICE_KEYS, VILLAGE_IMAGE } from '../data/content';
import { Clock } from 'lucide-react';

export default function Village() {
  const { t } = useLang();
  return (
    <div>
      <div className="max-w-3xl">
        <div className="flex items-center gap-2 mb-5">
          <Clock size={16} className="text-[#606F51]" />
          <span className="text-[11px] uppercase tracking-[0.24em] text-[#606F51] font-medium">
            {t.village.distance}
          </span>
        </div>
        <p className="text-[#4a4640] text-base md:text-lg leading-relaxed">
          {t.village.body}
        </p>
        <div className="flex flex-wrap gap-2 mt-7">
          {VILLAGE_SERVICE_KEYS.map((s) => (
            <span
              key={s}
              className="px-4 py-2 rounded-full bg-white border border-[#EAE4DA] text-[#2C2A26] text-[13px] font-medium"
            >
              {t.village.services[s]}
            </span>
          ))}
        </div>
      </div>

      <figure className="mt-10 md:mt-14 rounded-xl overflow-hidden shadow-md">
        <img
          src={VILLAGE_IMAGE}
          alt="Vista panoràmica de Cervià de les Garrigues"
          className="w-full h-[260px] md:h-[520px] object-cover"
          loading="lazy"
        />
        <figcaption className="bg-[#2C2A26] text-white/80 text-xs md:text-sm px-5 py-3 tracking-wide">
          Cervià de les Garrigues · Les Garrigues, Catalunya
        </figcaption>
      </figure>
    </div>
  );
}
